"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Successcasesgrid() {
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const galleryImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_1.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_1.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_1.png-wvc-sizes",
    alt: "Caso de éxito 1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_2.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_2.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_2.png-wvc-sizes",
    alt: "Caso de éxito 2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_3.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_3.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_3.png-wvc-sizes",
    alt: "Caso de éxito 3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_4.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_4.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_4.png-wvc-sizes",
    alt: "Caso de éxito 4"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_5.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_5.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_5.png-wvc-sizes",
    alt: "Caso de éxito 5"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_6.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_6.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_6.png-wvc-sizes",
    alt: "Caso de éxito 6"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_7.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_7.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_7.png-wvc-sizes",
    alt: "Caso de éxito 7"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_8.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_8.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_8.webp-wvc-sizes",
    alt: "Caso de éxito 8"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_9.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_9.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_9.png-wvc-sizes",
    alt: "Caso de éxito 9"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_10.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_10.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_10.png-wvc-sizes",
    alt: "Caso de éxito 10"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_11.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_11.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_11.png-wvc-sizes",
    alt: "Caso de éxito 11"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_12.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_12.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/placeholder_12.webp-wvc-sizes",
    alt: "Caso de éxito 12"
  }];
  return <section data-section-id="3356" id="successcasesgrid" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 transition-all duration-1000 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryImages.map((image, index) => <div key={index} data-index={index} className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-md bg-muted">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            </div>)}
        </div>
      </div>
    </section>;
}